<template lang="pug">
  .component.component-backoffice-reservation(v-if="item", :class="item.status")
    .card(v-if="$is('listing')")
      .inner-content
        CardN(:showBullets="true", :showAction="true", v-if="$is('listing')", :columns="6")
          .field-reservation-dropdown-buttons(slot="actionBullets")
            dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'top'")
              reservation-action-buttons(:reservation="item")
          .field-reservation-info(slot="n1")
            reservation-fields(:item="item", :fieldName="'reservation-id'", :type="'reservation-id'")
            driver(:type="'onlyname'", :item="item.driver")
          reservation-fields(slot="n1", :item="item", :fieldName="'reservation-bmode'")
          reservation-fields(slot="n2", :fieldName="'vehicle-info'", :item="item")
          reservation-fields(slot="n3", :item="item", :fieldName="'reservation-start'")
          reservation-fields(slot="n4", :item="item", :fieldName="'reservation-distance'")
          reservation-fields(slot="n4", :item="item", :fieldName="'reservation-cost'")
          BackofficeReservation(type="start-end-position", slot="n5", :item="item")
          reservation-fields(slot="n6", :item="item", :fieldName="'reservation-status'")

          .field-url-detail(slot="actionPage")
            router-link(:to="{name:'reservation', params:{id:item.id}}")
              i.fa.fa-angle-right.fa-3x.action
      .warning.progress.pm-progress.thin(v-if="item.status=='STARTED'")
        .progress-meter(style="width:70%;")
    .start-end-position(v-if="$is('start-end-position')")
      .owff(v-if="item.booking_mode === 'OWFF'")
        .extra-info
          span.fa-stack(style="color:green")
            i.fa.fa-circle-o.fa-stack-2x
            strong.fa-stack-1x D
          span &nbsp; {{item.extra.owff.pickup.name}}
        .extra-info(v-if="item.extra.owff.dropoff !== null")
          span.fa-stack(style="color:red")
            i.fa.fa-circle-o.fa-stack-2x
            strong.fa-stack-1x A
          span &nbsp; {{item.extra.owff.dropoff.name}}
      .parking-lot(v-else) PL{{item.vehicle.parking_lot.id}} {{item.vehicle.parking_lot.name}}
      .vehicle-slot VS{{item.vehicle.slot_id}} {{item.vehicle.vehicle_slot_address}}
    .card(v-if="$is('drv-res-list')")
      .inner-content
        card9(:showBullets="true", :showAction="true")
          .field-reservation-dropdown-buttons(slot="actionBullets")
            dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'top'")
              reservation-action-buttons(:reservation="item")
          .field-reservation-info(slot="n1")
            reservation-fields(:item="item", :fieldName="'reservation-id'", :type="'reservation-id'")
            img.vehicle-picture(:src="item.vehicle.picture_external")
          reservation-fields(slot="n2", :fieldName="'vehicle-info'", :item="item")

          .parking-lot(slot="n2") PL{{item.vehicle.parking_lot.id}} {{item.vehicle.parking_lot.name}}
          reservation-fields(slot="n3", :item="item", :fieldName="'reservation-start'")
          reservation-fields(slot="n4", :item="item", :fieldName="'reservation-end'")
          reservation-fields(slot="n5", :item="item", :fieldName="'reservation-bmode'")
          reservation-fields(slot="n6", :item="item", :fieldName="'reservation-distance'")
          reservation-fields(slot="n7", :item="item", :fieldName="'reservation-hours'")
          reservation-fields(slot="n8", :item="item", :fieldName="'reservation-cost'")
          reservation-fields(slot="n9", :item="item", :fieldName="'reservation-status'")
          .field-url-detail(slot="actionPage")
            router-link(:to="{name:'reservation', params:{id:item.id}}")
              i.fa.fa-angle-right.fa-3x.action
      .warning.progress.pm-progress.thin(v-if="item.status=='STARTED'")
        .progress-meter(style="width:70%;")

    .client-list(v-if="$is('client-list')")
      .card
        .inner-content
          card9(:showBullets="true", :showAction="true")
            .field-reservation-dropdown-buttons(slot="actionBullets")
              dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'top'")
                reservation-action-buttons(:reservation="item")
            reservation-fields(slot="n1", :item="item", :fieldName="'reservation-id'")
            .driver(slot="n1") {{item.driver.name}} {{item.driver.surname}}
            reservation-fields(slot="n2", :fieldName="'vehicle-info'", :item="item")
            reservation-fields(slot="n3", :item="item", :fieldName="'reservation-start'")
            reservation-fields(slot="n4", :item="item", :fieldName="'reservation-end'")
            reservation-fields(slot="n5", :item="item", :fieldName="'reservation-bmode'")
            reservation-fields(slot="n6", :item="item", :fieldName="'reservation-distance'")
            reservation-fields(slot="n7", :item="item", :fieldName="'reservation-hours'")
            reservation-fields(slot="n8", :item="item", :fieldName="'reservation-cost'")
            reservation-fields(slot="n9", :item="item", :fieldName="'reservation-status'")
            .field-url-detail(slot="actionPage")
              router-link(:to="{name:'reservation', params:{id:item.id}}")
                i.fa.fa-angle-right.fa-3x.action
    .vehicle-list(v-if="$is('vehicle-list')")
      .card
        .inner-content
          CardN(:showBullets="true", :showAction="true", :columns="6")
            .field-reservation-dropdown-buttons(slot="actionBullets")
              dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'top'")
                reservation-action-buttons(:reservation="item")
            .field-reservation-info(slot="n1")
              reservation-fields(:item="item", :fieldName="'reservation-id'", :type="'reservation-id'")
              driver(:type="'onlyname'", :item="item.driver")
            reservation-fields(slot="n1", :item="item", :fieldName="'reservation-bmode'")
            reservation-fields(slot="n2", :item="item", :fieldName="'reservation-start'")
            reservation-fields(slot="n3", :item="item", :fieldName="'reservation-distance'")
            reservation-fields(slot="n4", :item="item", :fieldName="'reservation-cost'")
            BackofficeReservation(type="start-end-position", slot="n5", :item="item")
            reservation-fields(slot="n6", :item="item", :fieldName="'reservation-status'")

            .field-url-detail(slot="actionPage")
              router-link(:to="{name:'reservation', params:{id:item.id}}")
                i.fa.fa-angle-right.fa-3x.action


    .card(v-if="$is('shortList')")
      .inner-content
        card5
          .field-url-detail(slot="n1")
            router-link(:to="{name:'reservation', params:{id:item.id}}") R{{item.number}}
          .field-vehicle(slot="n2")
            .field-value {{item.vehicle.model}}
            router-link(:to="{name:'vehicle', params:{id:item.vehicle.id}}") {{item.vehicle.plate}}
          div(slot="n3")
            router-link(:to="{name:'driver', params:{id:item.driver.id}}") {{item.driver.name}} {{item.driver.surname}}
          .field-reservation-start(slot="n4")
            .field-value {{$dateFormat(item.start, 'DD MMMM')}}
            .field-value {{$dateFormat(item.start, 'HH:mm')}}
          .field-reservation-end(slot="n5")
            .field-value {{$dateFormat(item.end, 'DD MMMM')}}
            .field-value {{$dateFormat(item.end, 'HH:mm')}}
    .sentinel(v-if="$is('sentinel')")
      .card
        .inner-content
          CardN(:showBullets="true", :showAction="true", :columns="4")
            .field-reservation-dropdown-buttons(slot="actionBullets")
              dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'top'")
                reservation-action-buttons(:reservation="item")
            .field-reservation-info(slot="n1")
              reservation-fields(:item="item", :fieldName="'reservation-id'", :type="'reservation-id'")
              driver(:type="'onlyname'", :item="item.driver")
            reservation-fields(slot="n1", :item="item", :fieldName="'reservation-bmode'")
            reservation-fields(slot="n2", :fieldName="'vehicle-info-no-img'", :item="item")
            reservation-fields(slot="n3", :item="item", :fieldName="'reservation-start-end'")
            reservation-fields(slot="n4", :item="item", :fieldName="'reservation-distance'")
            reservation-fields(slot="n4", :item="item", :fieldName="'reservation-cost'")
            a.fa.fa-globe.fa-2x(slot="n4" @click="$emit('locate')")
            //a.fa.fa-globe.fa-2x(slot="n5", @click="$emit('cazzo')")
            //.field-url-detail(slot="actionPage")
              router-link(:to="{name:'reservation', params:{id:item.id}}")
                i.fa.fa-angle-right.fa-3x.action


</template>

<script type="text/babel">
  import KeplerBackofficeSdk from '../../lib/kepler/backoffice'
  import MaggieHelper from '../../maggieHelper'
  import DatePicker from 'components/structure/DatePicker'
  import Dropdown from 'components/structure/foundation/Dropdown'
  import Card9 from 'components/structure/Card9'
  import ReservationActionButtons from 'components/structure/ui/actions/ReservationActionButtons'
  import Driver from 'components/backoffice/Driver'
  import Vehicle from 'components/backoffice/Vehicle'
  import Card4 from '../structure/Card4.vue'
  import Card5 from '../structure/Card5.vue'
  import ReservationFields from '../structure/ui/entity-fields/ReservationFields.vue'
  import Card8 from '../structure/Card8.vue'
  import CardN from '../structure/CardN'

  export default {
    name: 'BackofficeReservation',
    props: {
      item: Object,
      type: {
        type: String,
        default: ''
      },
      locate: {
        type: Function
      }
    },
    components: {
      CardN,
      Card8,
      ReservationFields,
      Card5,
      Card4,
      DatePicker,
      Dropdown,
      Card9,
      ReservationActionButtons,
      Driver,
      Vehicle
    },
    data() {
      return {
        endTime: null
      }
    },
    mounted() {
      this.endTime = null
    },
    destroyed() {
    },
    updated() {
      if (this.endTime == null) {
        this.endTime = this.item.end
      }
    },
    methods: {
      update: function () {
        this.$emit('updated', this.item)
      },

      open: function () {
        KeplerBackofficeSdk.reservations.select(this.item.number).open((response) => {
          this.update()
          MaggieHelper.notification('open-esit', 'vehicle open signal sent')
        })
      },
      close: function () {
        KeplerBackofficeSdk.reservations.select(this.item.number).close((response) => {
          this.update()
          MaggieHelper.notification('close-esit', 'vehicle close signal sent')
        })
      },

      cancel: function () {
        KeplerBackofficeSdk.reservations.select(this.item.number).cancel((response) => {
          this.update()
          MaggieHelper.notification('cancel-esit', 'reservation cancelled')
        })
      },

      terminate: function () {
        KeplerBackofficeSdk.reservations.select(this.item.number).terminate((response) => {
          this.update()
          MaggieHelper.notification('cancel-esit', 'reservation cancelled')
        })
      },

      extend: function () {
        KeplerBackofficeSdk.reservations.select(this.item.number).extend(this.convertTimestamp(this.endTime), (response) => {
          this.update()
          MaggieHelper.notification('extend-esit', 'reservation extended')
        })
      },

      pmvoid: function () {
        KeplerBackofficeSdk.reservations.select(this.item.number).void((response) => {
          this.update()
          MaggieHelper.notification('void-esit', 'reservation voided')
        })
      },

      convertTimestamp: function (datetime) {
        var t = datetime.split(/[- :]/)
        var date = new Date(t[0], t[1] - 1, t[2], t[3], t[4], t[5])
        return Math.round(date.getTime() / 1000)
      },

    },
  }
</script>

<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// Reservation.vue?3792d3b1